module.exports = __webpack_public_path__ + "img/product_126.ab2f548.webp";